import { render, staticRenderFns } from "./BannedWords.vue?vue&type=template&id=04e451ef&scoped=true"
import script from "./BannedWords.vue?vue&type=script&lang=js"
export * from "./BannedWords.vue?vue&type=script&lang=js"
import style0 from "./BannedWords.vue?vue&type=style&index=0&id=04e451ef&prod&lang=scss&scoped=true"
import style1 from "./BannedWords.vue?vue&type=style&index=1&id=04e451ef&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e451ef",
  null
  
)

export default component.exports